import React from 'react';
import { TORB1BackendRecord } from 'redux/app/orb1/@types';
import getSignTableRows from 'components/app/marpol/orb1/getSignTableRows';
import ORB1TableRows from 'components/app/marpol/orb1/ORB1TableRows';
type OwnProps = {
    orb1Record: TORB1BackendRecord;
    theme?: "light" | "dark";
};
type ORB1RecordParticipantsViewProps = OwnProps;
function ORB1RecordParticipantsView(props: ORB1RecordParticipantsViewProps) {
    const { orb1Record } = props;

    return (
        <ORB1TableRows
            record={orb1Record}
            tableRows={getSignTableRows(orb1Record)}
        />
    );
}

export default ORB1RecordParticipantsView;